import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Route } from './route';
import { Utils } from './utils';
import { Constants } from './constants';

@Injectable({
    providedIn: 'root'
})
export class GUI {

    constructor(private ngZone: NgZone, private router: Router, private route: Route, private utils: Utils, private constants: Constants) {

    }

    openHomePage(): void {
        this.ngZone.run(() => this.router.navigate([this.route.HOME]));
    }

    openDashboardPage(): void {
        this.ngZone.run(() => this.router.navigate([this.route.DASHBOARD]));
    }

    openApplicationAddEditPage(applicantId: string): void {
        if (this.utils.isEmpty(applicantId) === true) {
            this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_ADD_EDIT]));
        } else {
            this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_ADD_EDIT, this.utils.encryptString(applicantId)]));
        }
    }

    openApplicationViewPage(applicantId: string): void {
        this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_VIEW, this.utils.encryptString(applicantId)]));
    }

    openApplicationViewPageV1(applicationId: string, referenceId: string): void {
        this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_VIEW_V1, this.utils.encryptString(applicationId), this.utils.encryptString(referenceId)]));
    }

    openLogoutPage(): void {
        this.ngZone.run(() => this.router.navigate([this.route.LOGOUT]));
    }

    openApplicationSearchPage(): void {
        this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_SEARCH]));
    }

    openApplicationPreviewPageV1FromHome(applicationId: string, referenceId: string): void {
        this.ngZone.run(() => this.router.navigate([this.route.APPLICATION_VIEW_V1, this.utils.encryptString(applicationId), this.utils.encryptString(referenceId), this.utils.encryptString(this.constants.TRUE.toString())]));
    }

    openPaymentReceiptPage(applicantId: string): void {
        this.ngZone.run(() => this.router.navigate([this.route.PAYMENT_RECEIPT, this.utils.encryptString(applicantId)]));
    }

    openSelectPaymentPage(applicantId: string): void {
        this.ngZone.run(() => this.router.navigate([this.route.SELECT_PAYMENT, this.utils.encryptString(applicantId)]));
    }
}
